import React, { useState } from "react";
import { Typography, TextField } from "@mui/material";

interface EditablePlaylistNameProps {
    name: string;
    onSave: (newName: string) => void;
    /** Only the owner may rename. The sidebar now also lists playlists other people
     *  made, and double-clicking one of those must not offer an edit box. */
    editable?: boolean;
}

export default function EditablePlaylistName(props: EditablePlaylistNameProps) {
    const { name, onSave, editable = true } = props;
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(name);

    const handleDoubleClick = (e: React.MouseEvent) => {
        if (!editable) {
            return;
        }
        e.stopPropagation();
        setEditing(true);
    };
    const handleBlur = () => {
        setEditing(false);
        onSave(value);
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            setEditing(false);
            onSave(value);
        }
    };

    return editing ? (
        <TextField
            value={value}
            autoFocus
            variant="standard"
            size="small"
            onChange={e => setValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onClick={e => e.stopPropagation()}
            slotProps={{
                input: {
                    style: { fontWeight: 600, color: "#ffffff", fontSize: 15 },
                },
            }}
        />
    ) : (
        <Typography
            noWrap
            onDoubleClick={handleDoubleClick}
            title={value}
            sx={{
                cursor: editable ? "pointer" : "default",
                fontWeight: 600,
                color: "#ffffff",
                fontSize: 15,
            }}
        >
            {value}
        </Typography>
    );
}
